'use client';

import dynamic from 'next/dynamic';

const CreatorProfessionalPageClient = dynamic(
  () => import('./CreatorProfessionalPageClient'),
  { ssr: false }
);

export default function CreatorProfessionalPage() {
  return <CreatorProfessionalPageClient />;
}